<template>
  <div class="emd-panel__section">
    <div class="emd-panel__block">
      <div class="el-chunk">
        <p class="emd-text _type_caption">
          {{$t('title')}}
        </p>
      </div>
    </div>

    <div class="emd-panel__block">
      <div class="el-chunk">

        <div class="eu-flex eu-column eu-row_md">
          <div class="eu-flex-item eu-basis_5_md eu-basis_5_lg">
            <div class="emd-form-group">
              <label class="emd-label" :class="{ '_required': fieldsRequired }" for="zipcode">{{$t('zipcode')}}</label>
              <div class="emd-input-group">
                <the-mask
                  :masked="false"
                  class="emd-input"
                  mask="#####-###"
                  type="tel"
                  v-model="value.zip_code"
                  @input="searchZipCode"
                  v-bind:class="{ '_state_error': $v.value.zip_code.$invalid && $v.value.zip_code.$dirty }"
                  name="zipcode"
                  autocomplete="off"
                />
                <i v-if="loadingZipCode" class="emd-text _color_subtle uil uil-spinner" spin></i>
              </div>
              <p v-if="zipCodeNotFound" class="emd-input-feedback">{{ $t(`zipCodeNotFound`) }}</p>
              <!-- <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/" target="_blank" rel="noopener noreferrer" class="emd-input-link eu-display_inline-block">Não sei meu CEP</a> -->
            </div>
          </div>
        </div>

        <div class="eu-flex eu-column eu-row_md">
          <div class="eu-flex-item eu-basis_12">
            <div class="emd-form-group">
              <label class="emd-label" :class="{ '_required': fieldsRequired }" for="street">{{$t('street')}}</label>
              <input
                type="text"
                class="emd-input"
                v-model="value.street"
                @input="$v.value.street.$touch"
                v-bind:class="{ '_state_error': $v.value.street.$invalid  && $v.value.street.$dirty }"
                name="street"
                autocomplete="off"
              >
              <p class="emd-input-feedback">{{$t('streetInfo')}}</p>
            </div>
          </div>

          <div class="eu-flex-item eu-basis_6_md">
            <label class="emd-label" :class="{ '_required': fieldsRequired }" for="number">{{$t('number')}}</label>

            <div class="eu-flex eu-column eu-row_md eu-align-items_center">
              <div class="eu-flex-item eu-basis_9_md ">
                <div class="emd-form-group eu-no-padding_md eu-no-padding_lg">
                  <input
                    type="number"
                    class="emd-input"
                    v-model="value.number"
                    @input="$v.value.number.$touch"
                    v-bind:class="{ '_state_error': $v.value.number.$invalid && $v.value.number.$dirty, '_disabled': noNumber }"
                    name="number"
                    :disabled="noNumber"
                    autocomplete="off"
                  >
                </div>
              </div>

              <div class="eu-flex-item eu-basis_3_md eu-pb_4_mobile">
                <label class="emd-checkbox" for="noNumber">
                  <input class="emd-checkbox__input" type="checkbox" v-model="noNumber" id="noNumber">
                  <div class="emd-checkbox__area"></div>
                  <span class="emd-checkbox__text">{{$t('noNumber')}}</span>
                </label>
              </div>
            </div>

          </div>

          <div class="eu-flex-item eu-basis_6_md">
            <div class="emd-form-group">
              <label class="emd-label" for="complement">{{$t('complement')}}</label>
              <input
                type="text"
                class="emd-input"
                v-model="value.complement"
                name="complement"
                autocomplete="off"
              >
            </div>
          </div>

          </div>
        </div>
        <div class="eu-flex eu-column eu-row_md">
          <div class="eu-flex-item eu-basis_5_md">
            <div class="emd-form-group">
              <label class="emd-label" :class="{ '_required': fieldsRequired }" for="neighborhood">{{$t('neighborhood')}}</label>
              <input
                type="text"
                class="emd-input"
                v-model="value.neighborhood"
                @input="$v.value.neighborhood.$touch"
                v-bind:class="{ '_state_error': $v.value.neighborhood.$invalid  && $v.value.neighborhood.$dirty }"
                name="neighborhood"
                autocomplete="off"
              >
            </div>
          </div>
          <div class="eu-flex-item eu-basis_5_md">
            <div class="emd-form-group">
              <label class="emd-label" :class="{ '_required': fieldsRequired }" for="city">{{$t('city')}}</label>
              <input
                type="text"
                class="emd-input"
                v-model="value.city"
                @input="$v.value.city.$touch"
                v-bind:class="{ '_state_error': $v.value.city.$invalid  && $v.value.city.$dirty }"
                name="city"
                autocomplete="off"
              >
            </div>
          </div>

          <div class="eu-flex-item eu-basis_2_md">
              <div class="emd-form-group">
                <label class="emd-label" :class="{ '_required': fieldsRequired }" for="state">{{$t('state')}}</label>
                <input
                  type="text"
                  placeholder="UF"
                  class="emd-input eu-uppercase"
                  v-model="value.state"
                  @input="$v.value.state.$touch"
                  v-bind:class="{ '_state_error': $v.value.state.$invalid  && $v.value.state.$dirty }"
                  name="state"
                  autocomplete="off"
                >
              </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { TheMask } from 'vue-the-mask'
import { validationMixin } from 'vuelidate'
import { requiredIf, minLength } from 'vuelidate/lib/validators'
import UtilitiesCore from 'utilities-js'

const UtilitiesInstance = new UtilitiesCore({ environment: process.env.VUE_APP_CORE_ENV })

export default {
  name: 'EmdAddressBrazilianForm',
  mixins: [validationMixin],
  components: {
    TheMask
  },
  data () {
    return {
      loadingZipCode: false,
      zipCodeNotFound: false,
      canSearchZipCode: false
    }
  },
  props: {
    value: {
      required: true,
      type: Object,
      validator: value => ['city', 'complement', 'country', 'neighborhood', 'number', 'state', 'street', 'zip_code'].every(key => key in value)
    },
    searchZipCodeIsAllowed: {
      required: false,
      type: Boolean,
      default: true
    },
    fieldsRequired: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  computed: {
    zipCode () {
      return this.value.zip_code
    },
    formIsValid () {
      return !this.$v.value.$invalid
    },
    noNumber: {
      get () {
        if (this.value.number && this.value.number.toLowerCase() === 's/n') return true
        return false
      },
      set (val) {
        if (val) this.value.number = 'S/N'
        else this.value.number = ''
      }
    }
  },
  watch: {
    searchZipCodeIsAllowed (val) {
      if (val) this.searchZipCode(this.value.zip_code)
    },
    formIsValid (val) {
      this.$emit('formIsValid', val)
    }
  },
  validations: {
    value: {
      city: {
        required: requiredIf(function () { return this.fieldsRequired }),
        minLength: minLength(3)
      },
      country: {
        required: requiredIf(function () { return this.fieldsRequired })
      },
      neighborhood: {
        required: requiredIf(function () { return this.fieldsRequired }),
        minLength: minLength(1)
      },
      number: { required: requiredIf(function () { return this.fieldsRequired }) },
      state: { required: requiredIf(function () { return this.fieldsRequired }) },
      street: {
        required: requiredIf(function () { return this.fieldsRequired }),
        minLength: minLength(3)
      },
      zip_code: {
        required: requiredIf(function () { return this.fieldsRequired }),
        minLength: minLength(3)
      }
    }
  },
  methods: {
    searchZipCode (e) {
      this.$v.value.zip_code.$touch()
      if (this.searchZipCodeIsAllowed) {
        const zipCode = e
        if (zipCode && zipCode.length === 8) {
          this.loadingZipCode = true

          UtilitiesInstance.commons.getAddressByZipCode(zipCode)
            .then((response) => {
              this.loadingZipCode = false
              this.zipCodeNotFound = false
              this.canSearchZipCode = false
              this.value.street = response.street
              this.value.number = ''
              this.value.complement = ''
              this.value.neighborhood = response.district
              this.value.city = response.city
              this.value.state = response.state
            })
            .catch(() => {
              this.loadingZipCode = false
              this.value.street = ''
              this.value.number = ''
              this.value.complement = ''
              this.value.neighborhood = ''
              this.value.city = ''
              this.value.state = ''
              this.zipCodeNotFound = true
            })
        }
      }
    }
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "title": "Endereço",
    "zipcode": "CEP",
    "zipCodeNotFound": "Não conseguimos identificar o CEP. Confira o número, caso esteja correto, você pode prosseguir.",
    "street": "Logradouro",
    "streetInfo": "digite a rua, avenida ou similar",
    "number": "Número",
    "noNumber": "S/N",
    "complement": "Complemento",
    "neighborhood": "Bairro",
    "city": "Cidade",
    "state": "Estado"
  },
  "en-US": {
    "title": "Address",
    "zipcode": "Zipcode",
    "zipCodeNotFound": "We could not find the zipcode. Check your number, if it is correct, you can continue.",
    "street": "Street",
    "streetInfo": "street, avenue or similar",
    "number": "Number",
    "noNumber": "N/N",
    "complement": "Complement",
    "neighborhood": "Neighborhood",
    "city": "City",
    "state": "State"
  }
}
</i18n>
